import { Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React from 'react';

import RMFDropDown from '../../../../../../../RMFDropDown/RMFDropDown';

import {
  TXTCLI_Occupation,
  TXTWCL_Employee,
  TXTWCL_Freelancer,
  TXTWCL_No_occupation,
  TXTWCL_Please_select_your_occupation__ELL,
  TXTWCL_Retired,
  TXTWCL_Self_employed,
  TXTWCL_Student,
  TXTWCL_Trainee,
  TXTWCL_Unemployed
} from './Occupation.messages.json';
import { wrapper } from './Occupation.scss';

const FIELD_TYPE = 'profession';

enum OccupationType {
  NO_OCCUPATION = '0',
  SELF_EMPLOYED = '1',
  EMPLOYEE = '2',
  FREELANCER = '3',
  STUDENT = '4',
  RETIRED = '5',
  TRAINEE = '6',
  UNEMPLOYED = '7'
}
interface OccupationOption {
  text: JSX.Element;
  value: string;
}
const OPTIONS: OccupationOption[] = [
  {
    text: <Translation {...TXTWCL_No_occupation} />,
    value: OccupationType.NO_OCCUPATION
  },
  {
    text: <Translation {...TXTWCL_Self_employed} />,
    value: OccupationType.SELF_EMPLOYED
  },
  { text: <Translation {...TXTWCL_Employee} />, value: OccupationType.EMPLOYEE },
  { text: <Translation {...TXTWCL_Freelancer} />, value: OccupationType.FREELANCER },
  {
    text: <Translation {...TXTWCL_Student} />,
    value: OccupationType.STUDENT
  },
  { text: <Translation {...TXTWCL_Retired} />, value: OccupationType.RETIRED },
  { text: <Translation {...TXTWCL_Trainee} />, value: OccupationType.TRAINEE },
  { text: <Translation {...TXTWCL_Unemployed} />, value: OccupationType.UNEMPLOYED }
];

const Occupation: React.FC = () => (
  <RMFDropDown
    id={FIELD_TYPE}
    label={TXTCLI_Occupation}
    options={OPTIONS}
    validators={[required(TXTWCL_Please_select_your_occupation__ELL)]}
    className={wrapper}
  />
);

export default Occupation;
